import React from 'react';
import { flowRight as compose } from 'lodash';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { formValueSelector, change } from 'redux-form';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import ImageUploadComponent from '../../../../Common/ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../../CommonImageDisplay/CommonImageDisplay';

import messages from '../../../../../locale/messages';
import { doRemoveWhyHostImage } from '../../../../../actions/siteadmin/manageStaticBlock';
import { demoRestriction } from '../../../../../helpers/DemoRestriction/demoRestriction';

import s from './Image2.css';
import bt from '../../../../../components/commonStyle.css';

class Image2 extends React.Component {

  static defaultProps = {
    loader2: false
  };

  success = async (file, fromServer) => {
    const { change, demoRestriction } = this.props;
    let fileName = fromServer.file.filename;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await change('WhyHostForm', 'quoteSectionImage2', fileName);
  }

  deleteImage = async () => {
    const { doRemoveWhyHostImage, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await doRemoveWhyHostImage('quoteSectionImage2')
  }

  render() {
    const { loader2, image, quoteSectionLoader2 } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} className={s.textAlignCenter}>
          <div className={bt.picContainerMain}>
            <div className={cx(bt.picContainer)}>
              <CommonImageDisplay
                loader={quoteSectionLoader2}
                image={`/images/home/${image}`}
                isDelete={true}
                isDefaultPic={image ? false : true}
                deleteImage={this.deleteImage}
              />
            </div>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12} className={cx(s.spaceTop2)}>
          <div className={cx(s.fullWidth, s.button, bt.btnPrimary, s.noPadding, 'photoUploadBtn')}>
            <ImageUploadComponent
              defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
              componentConfig={{
                iconFiletypes: ['.jpg', '.png', '.jpeg'],
                multiple: false,
                showFiletypeIcon: false,
                postUrl: '/uploadHomeBanner'
              }}
              loaderName={'quoteSectionLoader2'}
              success={this.success}
            />
          </div>
        </Col>
      </Row>
    );
  }
}
const selector = formValueSelector('WhyHostForm');

const mapState = (state) => ({
  loader2: state?.image?.loader2,
  image: selector(state, 'quoteSectionImage2'),
  quoteSectionLoader2: state?.loader?.quoteSectionLoader2
});

const mapDispatch = {
  doRemoveWhyHostImage,
  change,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch)
)(Image2);